module.exports = __webpack_public_path__ + "static/media/listing-page-phuket.82df7496.jpg";